import React from 'react';
import { Stack, Text, Group } from '@mantine/core';
import { Lock } from 'lucide-react';
import { useNavigation } from '../contexts/NavigationContext';
import { usePremiumFeatures } from '../contexts/PremiumContext';
import { navigationItems } from '../config/navigation';
import { QuoteOfTheDay } from './QuoteOfTheDay';
import { FeedbackButton } from './FeedbackButton';
import { VersionDisplay } from './VersionDisplay';
import './NavigationBar.css';

interface NavigationBarProps {
  onShowFeedback?: () => void;
}

export const NavigationBar: React.FC<NavigationBarProps> = ({ onShowFeedback }) => {
  const { currentMode, setCurrentMode } = useNavigation();
  const { hasFeatureAccess } = usePremiumFeatures();

  const handleNavigation = (mode: any) => {
    // Always allow navigation - the RequirePremium wrapper will handle the premium check
    setCurrentMode(mode);
  };

  return (
    <Stack gap="md" className="navigation-bar" style={{ height: '100%' }}>
      <div style={{ padding: '16px' }}>
  {navigationItems.map(item => {
          const Icon = item.icon;
          const isActive = currentMode === item.id;
          
          // No separators between navigation items
          
          // Check if this is a premium feature
          const isPremiumFeature = item.id === 'kanban' || item.id === 'calendar';
          const featureName = item.id === 'kanban' ? 'KanbanBoards' : item.id === 'calendar' ? 'CalendarView' : undefined;
          const hasAccess = !isPremiumFeature || (featureName && hasFeatureAccess(featureName));
          
          return (
            <React.Fragment key={item.id}>
              <div
                onClick={() => handleNavigation(item.id)}
                className={`nav-item ${isActive ? 'nav-item-active' : ''} ${!hasAccess ? 'nav-item-premium' : ''}`}
                style={{
                  borderRadius: '8px',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  opacity: hasAccess ? 1 : 0.7,
                }}
              >
                <Group gap="md" align="center">
                  <Icon size={20} />
                  <div style={{ flex: 1 }}>
                    <Group gap="xs" align="center">
                      <Text size="sm" fw={500} className="nav-item-label">
                        {item.label}
                      </Text>
                      {!hasAccess && <Lock size={14} color="var(--app-text-muted)" />}
                    </Group>
                    {item.description && (
                      <Text size="xs" c="dimmed" className="nav-item-description" style={{ lineHeight: 1.3 }}>
                        {item.description}
                        {!hasAccess && ' (Premium)'}
                      </Text>
                    )}
                  </div>
                </Group>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      
      {/* Feedback button, Quote of the Day, and Version - pushed to bottom */}
      <div style={{ marginTop: 'auto' }}>
        {onShowFeedback && (
          <FeedbackButton onClick={onShowFeedback} variant="sidebar" />
        )}
        <QuoteOfTheDay />
        <VersionDisplay />
      </div>
    </Stack>
  );
};
